import { render, staticRenderFns } from "./ProductDisplayWidget.vue?vue&type=template&id=c812a9bc&scoped=true&"
import script from "./ProductDisplayWidget.vue?vue&type=script&lang=js&"
export * from "./ProductDisplayWidget.vue?vue&type=script&lang=js&"
import style0 from "./ProductDisplayWidget.vue?vue&type=style&index=0&id=c812a9bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c812a9bc",
  null
  
)

export default component.exports